// FIXME: the group of builders contained in /builders/suggestions are all used by suggestions modal
angular.module('capability-ng-scheduler').factory('CampusBuilder', function CampusBuilder(Interface) {
  var DTD = {
    id: 'key',
    name: 'string',
    is_online: 'boolean',
    _locations: 'ngArray'
  };

  function CampusDTO(data) {
    Interface.implement(DTD, data, this);
  }

  return CampusDTO;
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/course_scheduler/builders/suggestions/campus_builder.es.js